import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { deviceDetailedSchema } from '../types';

export const createGetDeviceInfoQuery = () =>
	createAuthQuery({
		params: declareParams<number>(),
		request: {
			method: 'GET',
			url: (id) => `/device/details/${id}`,
		},
		response: {
			contract: zodContract(deviceDetailedSchema),
		},
	});

export const getDeviceInfoQuery = createGetDeviceInfoQuery();
